import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Box } from '@mui/material';

export default function AUHeader() {
  const navigate = useNavigate();
  return (
    <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#1A7FFF', top: 0, zIndex: 1100 }}>
      <Toolbar sx={{ justifyContent: 'center', py: 1 }}>
        <Box
          onClick={() => navigate('/')}
          sx={{ cursor: 'pointer', bgcolor: '#fff', border: '2px solid rgba(255,255,255,0.9)', borderRadius: 1.5, px: 2, py: 0.75 }}
        >
          <Box component="img" src="/logo.jpg" alt="AU Coaching" sx={{ height: 36, objectFit: 'contain', display: 'block' }} />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
